import { useEffect, useState, useMemo } from 'react';
import {useLocation} from 'react-router-dom';

import { producaov2 } from '../../../../../../services/apis';

export const BOLETO_FILTERS = {
  INITIAL_DATE: 'initialDate',
  FINAL_DATE: 'finalDate',
  USER: 'user',
  PRODUCT: 'product'
}

export default function useBoletosList() {
  const [boletos, setBoletos] = useState({ data: [] });
  const [boletosDetail, setBoletosDetail] = useState({ total: 0, totalPaid: 0, totalPending: 0 });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [filter, setFilter] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const {search} = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    let isMounted = true;
    
    const getBoletos = async () => {
      setIsLoading(true);
      
      try {
        const response = await producaov2.get('admin/boletos', {
          params: {
            page,
            limit,
            id: query.get('id') || null,
            ...(filter?.[BOLETO_FILTERS.INITIAL_DATE] && {initialDate: filter[BOLETO_FILTERS.INITIAL_DATE]}),
            ...(filter?.[BOLETO_FILTERS.FINAL_DATE] && {finalDate: filter[BOLETO_FILTERS.FINAL_DATE]}),
            ...(filter?.[BOLETO_FILTERS.USER] && {user: filter[BOLETO_FILTERS.USER]}),
            ...(filter?.[BOLETO_FILTERS.PRODUCT] && {product: filter[BOLETO_FILTERS.PRODUCT]}),
          }
        });

        if(isMounted) {
          setBoletos(response.data);
        }
      } catch(error) {
        console.log(error);
      } finally {
        if(isMounted) {
          setIsLoading(false);
        }
      }
    }

    const getBoletosDetail = async () => {
      setBoletosDetail({ total: 0, totalPaid: 0, totalPending: 0 })

      try {
        const response = await producaov2.get('admin/boletos/detail', {
          params: {
            id: query.get('id') || null,
            ...(filter?.[BOLETO_FILTERS.INITIAL_DATE] && {initialDate: filter[BOLETO_FILTERS.INITIAL_DATE]}),
            ...(filter?.[BOLETO_FILTERS.FINAL_DATE] && {finalDate: filter[BOLETO_FILTERS.FINAL_DATE]}),
            ...(filter?.[BOLETO_FILTERS.USER] && {user: filter[BOLETO_FILTERS.USER]}),
            ...(filter?.[BOLETO_FILTERS.PRODUCT] && {product: filter[BOLETO_FILTERS.PRODUCT]}),
          }
        });

        if(isMounted) {
          setBoletosDetail(response.data);
        }
      } catch(error) {
        console.log(error);
      }
    }

    getBoletos();
    getBoletosDetail();

    return () => { isMounted = false }
  }, [page, limit, query, filter]);

  const onChangePage = (page) => {
    setPage(page);
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  const onChangeLimit = (limit) => {
    setLimit(limit);
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  const onSubmitFilter = (filters) => {
    setFilter(filters);
  }

  const onCleanFilter = () => {
    setFilter({});
  }

  return {
    data: boletos?.data,
    total: boletos?.paging?.total,
    boletosDetail,
    isLoading,
    page,
    limit,
    filter,
    onChangeLimit,
    onChangePage,
    onSubmitFilter,
    onCleanFilter
  }
}